export default {
  logout: {
    complete: '/logout',
  },
  dashboard: {
    complete: '/dashboard',
  },
  peerCategories: {
    complete: '/peer-categories',
    details: '/peer-categories/:peerCategoryId',
  },
  mandates: {
    complete: '/mandates',
    details: '/mandates/:mandateId',
    clusteringTool: {
      complete: '/mandates/:mandateId/clustering-tool',
    },
    optimizationTool: {
      compare: {
        complete: '/mandates/:mandateId/optimization-tool/compare',
      },
      complete: '/mandates/:mandateId/optimization-tool',
    },
  },
  users: {
    complete: '/users',
    create: {
      complete: '/users/create',
    },
    details: {
      complete: '/users/:userId',
      info: {
        complete: '/users/:userId/info',
        edit: {
          complete: '/users/:userId/info/edit',
        },
      },
      addresses: {
        complete: '/users/:userId/addresses',
        edit: {
          complete: '/users/:userId/addresses/edit/:addressId',
        },
        add: {
          complete: '/users/:userId/addresses/add',
        },
      },
      documents: {
        complete: '/users/:userId/documents',
        edit: {
          complete: '/users/:userId/documents/edit/:documentId',
        },
        add: {
          complete: '/users/:userId/documents/add',
        },
      },
      contacts: {
        complete: '/users/:userId/contacts',
        edit: {
          complete: '/users/:userId/contacts/edit',
        },
      },
    },
  },
  clusteringTool: {
    complete: '/clustering-tool',
  },
  investibleUniverse: {
    complete: '/investible-universe',
    instruments: {
      details: '/investible-universe/:type/:instrumentId',
    },
    mandates: {
      complete: '/investible-universe/mandates',
    },
    etfs: {
      complete: '/investible-universe/etfs',
    },
    equities: {
      complete: '/investible-universe/equities',
    },
    funds: {
      complete: '/investible-universe/funds',
    },
    bonds: {
      complete: '/investible-universe/bonds',
    },
  },
  profile: {
    complete: '/profile',
    info: {
      complete: '/profile/info',
      edit: {
        complete: '/profile/info/edit',
      },
    },
    addresses: {
      complete: '/profile/addresses',
      edit: {
        complete: '/profile/addresses/edit/:addressId',
      },
      add: {
        complete: '/profile/addresses/add',
      },
    },
    documents: {
      complete: '/profile/documents',
      edit: {
        complete: '/profile/documents/edit/:documentId',
      },
      add: {
        complete: '/profile/documents/add',
      },
    },
    contacts: {
      complete: '/profile/contacts',
      edit: {
        complete: '/profile/contacts/edit',
      },
    },
  },
};
